import { FC, PropsWithChildren, useEffect, useMemo, useState } from "react";
import { Terminology } from "@/types/v2";
import { useStore } from "@/stores/useStore";
import {
  defaultTerminology,
  TerminologyContext,
} from "@/contexts/TerminologyContext";

export const TerminologyProvider: FC<PropsWithChildren> = ({ children }) => {
  const [terminology, setTerminology] =
    useState<Terminology>(defaultTerminology);
  const { shop } = useStore();
  const shopTerminology = useMemo(
    () => shop?.shopConfig?.terminology ?? defaultTerminology,
    [shop]
  );

  useEffect(() => {
    setTerminology(shopTerminology);
  }, [shopTerminology]);

  return (
    <TerminologyContext.Provider value={{ terminology, setTerminology }}>
      {children}
    </TerminologyContext.Provider>
  );
};
